import { BaseApiClient } from './base-client'
import { API_ROUTES, ApiResponse } from '@super/shared-types'
import type {
  UnitResolutionPlan,
  UnitResolutionResponse,
  UnitValidationResponse,
} from '@super/shared-types'

export type {
  UnitResolutionData,
  UnitResolutionPlan,
  UnitResolutionResponse,
  UnitValidationError,
  UnitValidationWarning,
  UnitValidationResponse,
} from '@super/shared-types'

export interface UnitResolutionRequest {
  unitResolutionPlan: UnitResolutionPlan
  companyId: string
  options?: {
    updateExisting?: boolean
    continueOnError?: boolean
  }
}

export class UnitResolutionApiClient extends BaseApiClient {
  async executeUnitResolution(
    request: UnitResolutionRequest,
  ): Promise<UnitResolutionResponse> {
    const response = await this.request<ApiResponse<UnitResolutionResponse>>(
      API_ROUTES.UNIT_RESOLUTION.EXECUTE,
      { method: 'POST', body: JSON.stringify(request) },
    )
    if (!response.data) {
      throw new Error('No data returned from unit resolution')
    }
    return response.data
  }

  async validateUnitResolution(
    request: UnitResolutionRequest,
  ): Promise<UnitValidationResponse> {
    const response = await this.request<UnitValidationResponse>(
      API_ROUTES.UNIT_RESOLUTION.VALIDATE,
      { method: 'POST', body: JSON.stringify(request) },
    )
    return response
  }
}

export const unitResolutionApiClient = new UnitResolutionApiClient()
